





























import { defineComponent } from "@vue/composition-api";

import { Item } from "@/tools/msa/models/item";
import { HistoryManager } from "@/utils/history";
import { Document, Session } from "@/tools/msa/models";
import { groupItemsByType } from "@/tools/msa/utils/grouping";

import ItemRow from "@/tools/msa/components/table/ItemRow.vue";
import MetadataForm from "@/tools/msa/components/summary/MetadataForm.vue";
import GroupHeader from "@/tools/msa/components/table/ItemGroupHeader.vue";

interface Props {
  map: Map<string, Item[]>;
  session: Session;
  document: Document;
  selected: Item | null;
  history: HistoryManager<Item[]>;
}

export default defineComponent<Props>({
  name: "ItemTable",
  components: { MetadataForm, GroupHeader, ItemRow },
  props: {
    map: { type: Map, required: true },
    session: { type: Object, required: true },
    document: { type: Object, required: true },
    history: { type: Object, required: true },
    selected: { type: Object, default: () => null },
    showRepetitions: { type: Boolean, default: false }
  },
  setup(props: Props) {
    const itemsByType = groupItemsByType(props.history);

    return { itemsByType };
  }
});
